import { TableProps } from './Table.type';

import styles from './TableHead.module.scss';

type Props<T extends Record<string, unknown>> = Pick<TableProps<T>, 'headers'>;

export function TableHead<T extends Record<string, unknown>>({ headers }: Props<T>) {
  return (
    <thead>
      <tr>
        {headers.map(
          (header, index) =>
            !header.isHidden && (
              <td
                className={styles.td}
                key={header.content + index}
                width={header.width}
                style={{
                  minWidth: header.minWidth ? header.minWidth : 'none',
                }}
              >
                {header.content}
              </td>
            ),
        )}
      </tr>
    </thead>
  );
}
